var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { nonenumerable } from 'core-decorators';
import { Core } from '../../Constants';
export function Mixin(Base) {
    class IriTemplate extends Base {
        get template() {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return this.getString(Core.Vocab('template'), { strict: true });
        }
        get mappings() {
            return this.getArray(Core.Vocab('mapping'));
        }
        get variableRepresentation() {
            return this.get(Core.Vocab('variableRepresentation')) ||
                Core.Vocab('BasicRepresentation');
        }
    }
    __decorate([
        nonenumerable,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], IriTemplate.prototype, "template", null);
    __decorate([
        nonenumerable,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], IriTemplate.prototype, "mappings", null);
    __decorate([
        nonenumerable,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], IriTemplate.prototype, "variableRepresentation", null);
    return IriTemplate;
}
export const shouldApply = (res) => res.types.contains(Core.Vocab('IriTemplate'));
//# sourceMappingURL=IriTemplate.js.map